module.exports = __webpack_public_path__ + "franchise-05.png?30fb32a08a61b543f1c247d6fcb30ca3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/franchise-05.png
// module id = 266
// module chunks = 0